import React from "react";
import { Skeleton } from "antd";
import PresentationItem from "../components/PresentationItem";
const _ = require("lodash");

const getLivingTaxa = (metrics, rank) =>
  (_.get(metrics, `taxaByRankCount.${rank}`) || 0) -
  (_.get(metrics, `extinctTaxaByRankCount.${rank}`) || 0);
const getExtinctTaxa = (metrics, rank) =>
  _.get(metrics, `extinctTaxaByRankCount.${rank}`) || 0;

const getSearchParam = (dataset) => dataset.key ? `SECTOR_DATASET_KEY=${dataset.key}`: `SECTOR_PUBLISHER_KEY=${dataset.id}`


  export default ({ metrics, rank, style, dataset, pathToSearch }) => metrics && rank ? (
      <div style={style}>
        <React.Fragment>
          <PresentationItem label={`Living species`}>
          {dataset && pathToSearch ? <a href={`${pathToSearch}?${getSearchParam(dataset)}&rank=species&extinct=false&extinct=_NULL${_.isArray(dataset.sectorModes) ?  dataset.sectorModes.map((m) => `&sectorMode=${m}`).join("") : ""}`} >{getLivingTaxa(metrics, "species").toLocaleString("en-GB")}</a> : getLivingTaxa(metrics, "species").toLocaleString("en-GB")}
          </PresentationItem>
          <PresentationItem label={`Extinct species`}>
          {dataset && pathToSearch ? <a href={`${pathToSearch}?${getSearchParam(dataset)}&rank=species&extinct=true${_.isArray(dataset.sectorModes) ?  dataset.sectorModes.map((m) => `&sectorMode=${m}`).join("") : ""}`} >{getExtinctTaxa(metrics, "species").toLocaleString("en-GB")}</a> : getExtinctTaxa(metrics, "species").toLocaleString("en-GB")}
          </PresentationItem>
        </React.Fragment>
        {metrics.taxaByRankCount && Object.keys(metrics.taxaByRankCount)
          // .filter((r) => rank.indexOf(r) < rank.indexOf("species"))
          .sort((a, b) => rank.indexOf(b) - rank.indexOf(a))
          .map((k) => (
            <PresentationItem label={`${_.startCase(k)}`} key={k}>
             {dataset && pathToSearch ? <a href={`${pathToSearch}?${getSearchParam(dataset)}&rank=${k}&status=accepted&status=provisionally%20accepted${_.isArray(dataset.sectorModes) ?  dataset.sectorModes.map((m) => `&sectorMode=${m}`).join("") : ""}`} >{metrics.taxaByRankCount[k].toLocaleString("en-GB")}</a> : metrics.taxaByRankCount[k].toLocaleString("en-GB")}
            </PresentationItem>
          ))}
        <PresentationItem label={"Synonyms"} key={"Synonyms"}>
        {dataset && pathToSearch ? <a href={`${pathToSearch}?${getSearchParam(dataset)}&status=misapplied&status=synonym&status=ambiguous%20synonym${_.isArray(dataset.sectorModes) ?  dataset.sectorModes.map((m) => `&sectorMode=${m}`).join("") : ""}`} >{(metrics.synonymCount || 0).toLocaleString("en-GB")}</a> : (metrics.synonymCount || 0).toLocaleString("en-GB")}
        </PresentationItem>
        <PresentationItem label={"Common names"} key={"vernaculars"}>
          {(metrics.vernacularCount || 0).toLocaleString("en-GB")}
        </PresentationItem>
        <PresentationItem label={"Total number of names"} key={"names"}>
        {dataset && pathToSearch ? <a href={`${pathToSearch}?${getSearchParam(dataset)}${_.isArray(dataset.sectorModes) ?  dataset.sectorModes.map((m) => `&sectorMode=${m}`).join("") : ""}`} >{(metrics.nameCount || 0).toLocaleString("en-GB")}</a> : (metrics.nameCount || 0).toLocaleString("en-GB")}
        </PresentationItem>
      </div>
    ) : (
      <PresentationItem label="">
        <Skeleton active paragraph={{ rows: 4 }} />
      </PresentationItem>
    );
 
